export enum FolioTypeLowerCase {
    PREVENTIVE = 'preventivo',
    CORRECTIVE = 'correctivo'
}